import type * as React from "react";
import { Box, Typography } from "@mui/material";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import SecurityIcon from "@mui/icons-material/Security";
import { PATHS } from "constants/pathConstants";
import PageTitle from "utils/PageTitle";
import GradientFramedLayout from "components/v3/layouts/GradientFramedLayout";
import BreadcrumbTrail from "components/v3/sharedComponents/BreadcrumbTrail";
import AccountManagementMenuRow from "components/v3/pages/account/AccountManagementPage/AccountManagementMenuRow";
import AccountSecurityCallout from "components/v3/pages/account/AccountManagementPage/AccountSecurityCallout";
import { COLORS } from "components/v3/Theme/colors";

const PAGE_HEADING = "Privacy & Security";

const menuIcon = (Icon: typeof LockOutlinedIcon) => (
  <Icon sx={{ color: COLORS.PRIMARY, fontSize: 19 }} />
);

const PrivacySecurityPage: React.FC = () => {
  PageTitle(PAGE_HEADING);

  const menuItems = [
    {
      id: "res-pass",
      label: "Reset Password",
      icon: menuIcon(LockOutlinedIcon),
      to: PATHS.ACCOUNT_MANAGEMENT_RESET_PASSWORD
    },
    {
      id: "terms-serv",
      label: "Terms of Service",
      icon: menuIcon(DescriptionOutlinedIcon),
      to: PATHS.ACCOUNT_MANAGEMENT_AGREEMENTS
    },
    {
      id: "mfa",
      label: "Multi-Factor Authentication",
      icon: menuIcon(SecurityIcon),
      to: PATHS.ACCOUNT_MANAGEMENT_MFA
    }
  ];

  return (
    <GradientFramedLayout showHeader={true}>
      <Box
        sx={{
          boxSizing: "border-box",
          display: "flex",
          flex: 1,
          flexDirection: "column",
          minHeight: 0,
          width: "100%"
        }}
      >
        <Box
          sx={{
            alignItems: "center",
            boxSizing: "border-box",
            display: "flex",
            flex: 1,
            flexDirection: "column",
            gap: 3,
            marginX: "auto",
            maxWidth: 500,
            minWidth: 0,
            paddingBottom: "40px",
            paddingTop: { md: 3, xs: 2 },
            paddingX: { md: 3, xs: 2 },
            width: "100%"
          }}
        >
          <Typography
            variant="h4_primary"
            component="h1"
            sx={{ fontWeight: 700, textAlign: "left", width: "100%" }}
          >
            {PAGE_HEADING}
          </Typography>

          <BreadcrumbTrail
            segments={[
              { label: "Account", to: PATHS.ACCOUNT_MANAGEMENT },
              { label: PAGE_HEADING }
            ]}
          />

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1.5,
              minWidth: 0,
              width: "100%"
            }}
          >
            {menuItems.map((item) => (
              <AccountManagementMenuRow
                key={item.id}
                id={item.id}
                label={item.label}
                icon={item.icon}
                to={item.to}
              />
            ))}
          </Box>

          <Box
            sx={{
              flexShrink: 0,
              marginTop: "auto",
              width: "100%"
            }}
          >
            <AccountSecurityCallout />
          </Box>
        </Box>
      </Box>
    </GradientFramedLayout>
  );
};

export default PrivacySecurityPage;
